import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from "js-cookie";
Vue.use(Vuex);

const initialState = () => {
  return {
    sidabarShow: 'response',
    sidebarMinimize: false,
    currentUser: '',
    permissions: [],
    token: null
  }
}

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  currentUser: Cookies.get('currentUser')
    ? JSON.parse(Cookies.get('currentUser'))
    : '',
  permissions: Cookies.get('permissions') 
    ? JSON.parse(Cookies.get('permissions')) 
    : [],
  token: Cookies.get('token')
    ? JSON.parse(Cookies.get('token'))
    : null
}

const actions = {
  setPermissions({ commit }, payload) {
      commit("SET_PERMISSIONS", payload);
  },
  setStore({ commit }, payload) {
    commit("set", payload);
  },
  resetState({ commit }) {
    commit('RESET_STATE')
  }
};

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value;
    Cookies.set(variable, JSON.stringify(state[variable]));
  },
  SET_PERMISSIONS(state, payload) {
    state.permissions = payload;
    Cookies.set("permissions", JSON.stringify(state.permissions));
  },
  RESET_STATE(state) {
    Object.assign(state, initialState());
    Object.keys(Cookies.get()).forEach(function(cookieName) {
      Cookies.remove(cookieName);
    });
    localStorage.removeItem('api_token');
  }
}

export default new Vuex.Store({
  state,
  actions,
  mutations
})